export default __webpack_public_path__ + "static/media/ss12.e3d669a3.jpg";